import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-no-internet',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './no-internet.html',
  styleUrl: './no-internet.scss'
})
export class NoInternetComponent {
  @Output() retry = new EventEmitter<void>();

  retryConnection(): void {
    this.retry.emit();
  }
}
